export default __webpack_public_path__ + "static/media/pointingtv.f50acf6e.jpg";